import { compare, minVersion, satisfies } from 'semver';

/**
 * Returns the most specific semver range (i.e., with the highest minVersion)
 * from a list of ranges that satisfies a given version.
 */
export function getMostSpecificMatchingRange(version: string, ranges: string[]): string | undefined {
  // Filter ranges that satisfy the given version
  const matching = ranges.filter((r) => satisfies(version, r));

  // Sort matching ranges by their minVersion (higher min = more specific)
  const sorted = matching.sort((a, b) => {
    const minA = minVersion(a);
    const minB = minVersion(b);

    // If either range is invalid or unparsable, treat them as equal
    if (!minA || !minB) return 0;

    // Compare their minimum versions
    return compare(minA, minB);
  });

  // Return the most specific one (last in the sorted list)
  return sorted.at(-1);
}
